export const FISERV_PORTAL_URL = 'https://sgts.firstdata.com/sgts/servlet/com.fiserv.geologin';
export const VISA_CALL_CENTER_PHONE = '1840';
export const AMEX_CALL_CENTER_PHONE = '(598)29166655';

/** @deprecated Usar VISA_CALL_CENTER_PHONE o resolveCallCenterPhone */
export const CALL_CENTER_PHONE = VISA_CALL_CENTER_PHONE;

/** Siempre autorizar por Fiserv, cualquier sello */
export const FISERV_ALWAYS_CARRIER_CODES = ['LA', 'CM', 'UX', 'H2'] as const;

/** Mastercard y otros sellos → Fiserv; Visa → call center Visa */
export const FISERV_EXCEPT_VISA_CALL_CARRIER_CODES = ['AR', 'G3', 'AV', 'IB'] as const;

/** Venta internacional / solo GDS (sin Fiserv ni 1840 para la autorización de tarjeta) */
export const GDS_ONLY_CARRIER_CODES = ['AF', 'UA'] as const;

/** Sin aceptación de tarjetas por el momento */
export const NO_CARD_CARRIER_CODES = ['LH'] as const;

/** Los canales por donde se autoriza; `unknown` = sin definir. Son también los `channel` de las reglas de la base. */
export const AUTHORIZATION_CHANNELS = ['fiserv', 'call_center', 'gds', 'no_cards', 'unknown'] as const;

export type AuthorizationChannel = (typeof AUTHORIZATION_CHANNELS)[number];

export type NormalizedCardStamp = 'visa' | 'mastercard' | 'amex' | 'oca' | 'cabal' | 'diners' | 'other';

export const normalizeCardStamp = (cardStamp: string): NormalizedCardStamp => {
	const normalized = cardStamp.trim().toLowerCase();

	if (normalized.includes('visa')) return 'visa';
	if (normalized.includes('master')) return 'mastercard';
	if (normalized.includes('amex') || normalized.includes('american')) return 'amex';
	if (normalized.includes('oca')) return 'oca';
	if (normalized.includes('cabal')) return 'cabal';
	if (normalized.includes('diner')) return 'diners';

	return 'other';
};

export const isVisaStamp = (cardStamp: string): boolean => normalizeCardStamp(cardStamp) === 'visa';

export const isAmexStamp = (cardStamp: string): boolean => normalizeCardStamp(cardStamp) === 'amex';

export const isUnsupportedCardStamp = (cardStamp: string): boolean => {
	const stamp = normalizeCardStamp(cardStamp);
	return stamp === 'cabal' || stamp === 'diners';
};

export const resolveCallCenterPhone = (cardStamp: string): string =>
	isAmexStamp(cardStamp) ? AMEX_CALL_CENTER_PHONE : VISA_CALL_CENTER_PHONE;

export const resolveAuthorizationChannel = (carrierCode: string, cardStamp: string): AuthorizationChannel => {
	if (isUnsupportedCardStamp(cardStamp)) {
		return 'no_cards';
	}

	const code = carrierCode.toUpperCase();

	if (NO_CARD_CARRIER_CODES.includes(code as (typeof NO_CARD_CARRIER_CODES)[number])) {
		return 'no_cards';
	}

	if (GDS_ONLY_CARRIER_CODES.includes(code as (typeof GDS_ONLY_CARRIER_CODES)[number])) {
		return 'gds';
	}

	if (isAmexStamp(cardStamp)) {
		return 'call_center';
	}

	if (FISERV_ALWAYS_CARRIER_CODES.includes(code as (typeof FISERV_ALWAYS_CARRIER_CODES)[number])) {
		return 'fiserv';
	}

	if (FISERV_EXCEPT_VISA_CALL_CARRIER_CODES.includes(code as (typeof FISERV_EXCEPT_VISA_CALL_CARRIER_CODES)[number])) {
		return isVisaStamp(cardStamp) ? 'call_center' : 'fiserv';
	}

	return 'unknown';
};

export const getChannelLabel = (channel: AuthorizationChannel): string => {
	switch (channel) {
		case 'fiserv':
			return 'Fiserv (panel online)';
		case 'call_center':
			return 'Call center';
		case 'gds':
			return 'GDS (venta internacional)';
		case 'no_cards':
			return 'Sin tarjetas habilitadas';
		default:
			return 'Consultar procedimiento';
	}
};
